import { render, staticRenderFns } from "./OcupacionFamilia.vue?vue&type=template&id=c17d2b12&"
import script from "./OcupacionFamilia.vue?vue&type=script&lang=js&"
export * from "./OcupacionFamilia.vue?vue&type=script&lang=js&"
import style0 from "./OcupacionFamilia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OcupacionFamilia.vue"
export default component.exports